module.exports = __webpack_public_path__ + "static/media/reporte2012.cb68263d.png";